module.exports = __webpack_public_path__ + "img/award-100.c5c5d1cf.jpg";